export function orderLoginChoices<T>(
    builtIn: T[],
    custom: T[],
    companyAuthenticationId: number,
    customSamlCatalogId: number | undefined,
): T[] {
    if (customSamlCatalogId != null && companyAuthenticationId === customSamlCatalogId) {
        return custom.concat(builtIn);
    }
    return builtIn.concat(custom);
}
